import { render, staticRenderFns } from "./CargaResultado2026.vue?vue&type=template&id=2a6aebe2&scoped=true&"
import script from "./CargaResultado2026.vue?vue&type=script&lang=js&"
export * from "./CargaResultado2026.vue?vue&type=script&lang=js&"
import style0 from "./CargaResultado2026.vue?vue&type=style&index=0&id=2a6aebe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6aebe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCard,VCardTitle,VCol,VDivider,VIcon,VRow,VTextField})
